import { useMemo } from 'react';
import { useLocation } from 'react-router';
import queryString from 'query-string';

import { newLawnRoute } from '~/routes';
import { useModal } from '~/features/modals/modal-actions';
import { AuthType } from '~/components/modals/funnel-auth/funnel-auth-modal';
import { analyticsBeacon, DeprecatedEventType } from '~/utils/analytics';
import { useSession } from '~/features/session/session-actions';
import { REGISTRATION_SOURCES } from '~/components/modals/funnel-auth/register-modal-form';

export const useFunnelRequireAuth = ({ content, onModalClose } = {}) => {
  const { getUser } = useSession();
  const location = useLocation();
  const queryParams = useMemo(
    () => queryString.parse(location.search),
    [location.search]
  );
  const { showModal } = useModal();

  const requireAuth = () => {
    const user = getUser();
    const isSignedIn = Boolean(user); // Ensures that `isSignedIn` is accurate at call time of `requireAuth`
    return new Promise((resolve) => {
      if (isSignedIn) {
        resolve(user);
        return;
      }

      showModal('FUNNEL_AUTH', {
        magicLinkRedirectUrl: newLawnRoute({
          ...queryParams,
          skipLoad: true,
        }),
        onAuth: (type, userData) => {
          if (type === AuthType.REGISTER) {
            analyticsBeacon.emit(DeprecatedEventType.LEAD_LAWN_FUNNEL, {
              funnelType: 'Lawn Funnel',
              userUuid: userData?.uuid,
            });
          }

          resolve(userData);
        },
        onClose: onModalClose,
        source: REGISTRATION_SOURCES.LAWN_FUNNEL,
        content,
      });
    });
  };

  return {
    requireAuth,
  };
};
